import { render, staticRenderFns } from "./dialogManager.vue?vue&type=template&id=ccb2b9b6&scoped=true&lang=pug&"
import script from "./dialogManager.vue?vue&type=script&lang=js&"
export * from "./dialogManager.vue?vue&type=script&lang=js&"
import style0 from "./dialogManager.vue?vue&type=style&index=0&id=ccb2b9b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb2b9b6",
  null
  
)

export default component.exports